import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white mt-12">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 text-center">
        <div className="flex items-center justify-center space-x-3 mb-2">
          <img 
            src="/logos/frontend/logo.svg" 
            alt="Snag Your Tee" 
            className="w-6 h-6 md:w-8 md:h-8 object-contain"
          />
          <span className="text-lg font-medium">Snag Your Tee</span>
        </div>
        <p className="text-gray-300">
          © 2025 Snag Your Tee. Making every golf game a breeze and fun.
        </p>
      </div>
    </footer>
  );
}

export default Footer;